import React from 'react'
import { Button, Icon } from 'antd'

import './VisionSummaryCard.scss'

const VisionSummaryCard = ({
  creativeStatement,
  isVisionLocked,
  onTogglePhase
}) => (
  <section className="creative-direction-chat__phase-summary">
    <div className="creative-direction-chat__phase-summary-icon">
      <Icon type="star" />
    </div>
    <div>
      <span>Vision</span>
      <strong>
        {isVisionLocked
          ? 'Vision locked'
          : creativeStatement
          ? 'Vision statement ready'
          : 'Vision conversation started'}
      </strong>
    </div>
    <Button size="small" onClick={onTogglePhase}>
      View details
    </Button>
  </section>
)

export default VisionSummaryCard
